import { Checkbox, Stack} from '@chakra-ui/react';

const CallbackMetricSelector = ({tempWidget, setTempWidget}) => {

    const handleChange = (metricName) => {
            let newStatArray = [];
            newStatArray.push(metricName);
            
            let updatedWidgetObject = {...tempWidget};
            updatedWidgetObject['statistic'] = newStatArray;
            updatedWidgetObject['type'] = 'callback';
            setTempWidget(updatedWidgetObject);
    }; 

    return (

        <Stack spacing={3} direction='column'>
            <Checkbox
                name='CALLBACKS_WAITING'
                isChecked={tempWidget.statistic.includes('CALLBACKS_WAITING')}
                onChange={(e) => handleChange('CALLBACKS_WAITING')}
            >
                Callbacks Waiting
            </Checkbox>
            <Checkbox
                name='OLDEST_CALLBACK'
                isChecked={tempWidget.statistic.includes('OLDEST_CALLBACK')}
                onChange={(e) => handleChange('OLDEST_CALLBACK')}
            >
                Oldest Callback
            </Checkbox>
        </Stack>
    );
};

export default CallbackMetricSelector;